import { WebEventNames } from './eventNames'
import { getEventTracker } from '@libs/eventTracking'
import {
  getCurrentPagePropertyFor,
  getNextPagePropertyFor,
} from '@libs/eventTracking/eventPropertyUtils'
import omitBy from 'lodash/omitBy'
import isNil from 'lodash/isNil'
import { getFilterVale } from '@libs/eventTracking/search/web-search.sort.switch'

export interface TrackSearchHotKeywordSearchEventInput {
  toPageUrl?: string
  searchKeyword?: string
  typeFilter?: string
  sortFilter?: string
}

/**
 * [Link to spec](https://github.com/popdaily/popdaily.tracking/blob/develop/tracking_events/events/web-search/web-search.hot-keyword.search.md)
 */
export function trackSearchHotKeywordSearchEvent(
  input: TrackSearchHotKeywordSearchEventInput,
): void {
  const { toPageUrl, searchKeyword, typeFilter, sortFilter } = input
  getEventTracker().track({
    name: WebEventNames.WEB_SEARCH_HOT_KEYWORD_SEARCH,
    properties: omitBy(
      {
        toPage: getNextPagePropertyFor({ pageName: 'web-search', pageUrl: toPageUrl }),
        currentPage: getCurrentPagePropertyFor('web-search'),
        searchKeyword,
        typeFilter: getFilterVale(typeFilter),
        sortFilter: getFilterVale(sortFilter),
      },
      isNil,
    ),
  })
}
